import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  EventEmitter,
  Output,
} from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { Sort } from "@angular/material/sort";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-productviewlist",
  templateUrl: "./productviewlist.component.html",
  styleUrls: ["./productviewlist.component.css"],
})
export class ProductviewlistComponent implements OnInit {
  displayedColumns: string[] = [
    "ProjectName",
    "InquiryName",
    "CustomerName",
    "SOOption",
    "MTINumber",
    "Stage",
    "Status",
    "SOAcknowledgement",
    "EquipmentDeliveryDate",
    "CreatedByName",
    "CreatedDate",
    "Action",
  ];
  sortData: any = { column: "EmployeeId", direction: "asc" };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() clearEvent = new EventEmitter<void>();
  dtOptions: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSo: any = {};
  searchword: any = "";
  currentPage: any = 0;
  pageSize: any = 10;
  dataSource: any;
  showOrder: any = [];
  ItemPerPages: number = 0;
  TotalRecord: any;
  totalSize: number = 0;
  showInquiryArray: any = [];
  showCustomerArray: any = [];
  showStageArray: any = [];
  showDdValuesArray: any = [];
  showTable: boolean;
  start: any = "";
  start2: any = "";
  end: any = "";
  end2: any = "";
  start_date: string;
  end_date: string;
  timezone: any;
  type: string;
  namesort: string;
  permission: any;
  roleId: any;
  upicon: boolean;
  downicon: boolean;
  columnsort: string;
  OrderId: any;
  CriticalShipment: any;
  filterForm: FormGroup;
  PrName: any;
  InqName: any;
  deleteId: any;
  modalRef: BsModalRef;
  delstatus: any;
  isValid: boolean;
  err_message: any;
  Revision: any;
  forwardId: any;
  rejectId: any;
  approveId: any;
  userId: any;
  ForwardForm: FormGroup;
  RejectForm: FormGroup;
  multiClick: boolean = false;
  Modulepermi: any;
  Pid: any;
  Iid: any;
  disableDate() {
    return false;
  }

  constructor(
    private UserService: UserService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
    this.filterForm = this.formBuilder.group({
      ProjectId: [""],
      InquiryId: [""],
      CustomerId: [""],
      CriticalShipment: [""],
      Stage: [""],
      SOOption: [""],
      EquipmentDeliveryDate: [""],
      TargetCompletionDate: [""],
    });
  }

  selectedItems: any[] = [];
  dropdownSettings = {};

  dropdownList2 = [];
  selectedItems2 = [];
  dropdownSettings2 = {};

  dropdownList1 = [];
  dropdownSetting = {};

  dropdownList3 = [];
  selectedItems3 = [];
  dropdownSettings3 = {};
  dropdownList5 = [];
  selectedItems5 = [];
  dropdownSettings5 = {};
  isCollapsed: any;
  optionsPro: string[] = [];
  showProjectArray: any = [];
  date_range: any = { startDate: moment, endDate: moment };
  date_range2: any = { startDate2: moment, endDate2: moment };

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  ngOnInit(): void {
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let rId = localStorage.getItem("roleId");
    this.roleId = this.UserService.decryptData(rId);
    let UserId = localStorage.getItem("userId");
    this.userId = this.UserService.decryptData(UserId);
    let modulePermi = JSON.parse(localStorage.getItem("ModulePermission"));
    this.Modulepermi = this.UserService.decryptData(modulePermi);
    if (this.Modulepermi.OrderReview != 1 && this.userId != 1) {
      this.toastr.error("You do not have permission");
      this.router.navigate(["/profile"]);
      return;
    }
    this.isCollapsed = false;
    this.date_range = { startDate: moment, endDate: moment };
    this.date_range2 = { startDate2: moment, endDate2: moment };
    this.date_range.startDate = "";
    this.date_range.endDate = "";
    this.date_range2.startDate2 = "";
    this.date_range2.endDate2 = "";
    this.date_range = null;
    this.date_range2 = null;
    this.getproject();
    this.getinquiry();
    this.getcustomer();
    this.getstage();
    this.ddValues();

    this.ForwardForm = this.formBuilder.group({
      ResonValue: [""],
    });

    this.RejectForm = this.formBuilder.group({
      ResonValue: [""],
    });

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownList2 = [
      { id: 13, itemName: "IQTR201019 " },
      { id: 14, itemName: "IQTR201010" },
    ];

    this.selectedItems2 = [
      { id: 13, itemName: "IQTR201019 " },
      { id: 14, itemName: "IQTR201010" },
    ];
    this.dropdownSettings2 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownList3 = [
      { id: 13, itemName: "Narendra " },
      { id: 14, itemName: "Vishesh" },
    ];

    this.selectedItems3 = [
      { id: 13, itemName: "Narendra " },
      { id: 14, itemName: "Vishesh" },
    ];
    this.dropdownSettings3 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownList1 = [
      { id: 1, itemName: "Yes" },
      { id: 0, itemName: "No" },
    ];

    this.dropdownSetting = {
      singleSelection: true,
      text: "Critical Shipment",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownSetting2 = {
      singleSelection: false,
      text: "Inquiry Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting3 = {
      singleSelection: false,
      text: "Customer Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting4 = {
      singleSelection: false,
      text: "Stages",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownList5 = [
      { id: 13, itemName: "Design" },
      { id: 14, itemName: "Tender" },
    ];

    this.selectedItems5 = [
      { id: 13, itemName: "Design" },
      { id: 14, itemName: "Tender" },
    ];
    this.dropdownSettings5 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };
    this.dropdownSetting1 = {
      singleSelection: false,
      text: "Project Name",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSo = {
      singleSelection: false,
      text: "So Options",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    let data = {
      ProjectId: "",
      InquiryId: "",
      CustomerId: "",
      CriticalShipment: "",
      SOType: "",
      Stage: "",
      SOOption: "",
      EquipmentDeliveryStartDate: "",
      EquipmentDeliveryEndDate: "",
      TargetCompletionStartDate: "",
      TargetCompletionEndDate: "",
      SearchWord: this.searchword,
      Sort: "",
      SortWise: "",
      Status: "",
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.spinner.show();
    this.UserService.OrderReviewListFilter(data).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.currentPage = 0;
          this.showOrder = response["OrderReviewList"];
          this.dataSource = new MatTableDataSource<any>(
            response["OrderReviewList"]
          );
          this.dataSource.paginator = this.paginator;
          this.TotalRecord = response["TotalRecord"];
          this.totalSize = response["TotalRecord"];
          this.iterator();
        } else if (response["result"] == "Failed") {
          this.toastr.error(response["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(response["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  get f() {
    return this.filterForm.controls;
  }

  toggleFilter() {
    setTimeout(() => {
      this.isCollapsed = !this.isCollapsed;
    }, 0);
  }

  clearStartDate() {
    this.date_range = null;
  }

  clearEndDate() {
    this.date_range = null;
    this.date_range2 = null;
  }

  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  showProject: any = [];
  getproject() {
    this.optionsPro = [];
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProjectArray = res;
        for (const projectData of this.showProjectArray["Data"]) {
          if (projectData["Status"] == 1) {
            this.showProject.push({
              id: projectData["ProjectId"],
              itemName: `${projectData["ProjectName"]} (${projectData["ProjectNumber"]})`,
            });
            this.optionsPro.push(projectData["ProjectName"]);
          }
        }
      } else {
        this.showProjectArray = [];
        this.optionsPro = [];
      }
    });
  }
  selectedProject: any = [];
  selectedProjectName: any;
  selectedProjectNameId: any;
  onProjectSelect(item: any) {
    this.selectedProjectName = "";
    this.selectedProjectNameId = "";
    this.selectedProject.forEach((element) => {
      this.selectedProjectName += element["itemName"] + ", ";
      this.selectedProjectNameId += element["id"] + ", ";
    });
  }

  selectedCriticalName: any;
  selectedCriticalId: any;
  onCriticalSelect(item: any) {
    this.dropdownList1.forEach((element) => {
      this.selectedCriticalName = element["itemName"];
      this.selectedCriticalId = item.id;
    });
  }

  showInquiry: any = [];
  getinquiry() {
    let data = {};
    this.UserService.GetInquiryNumber(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showInquiryArray = res;
        this.showInquiry = [];
        for (const inquiryData of this.showInquiryArray["Data"]) {
          this.showInquiry.push({
            id: inquiryData["InquiryId"],
            itemName: `${inquiryData["InquiryName"]} (${inquiryData["InquiryNumber"]})`,
          });
        }
      } else {
        this.showInquiryArray = [];
      }
    });
  }
  selectedinquiry: any = [];
  selectedInquiry: any;
  selectedInquiryId: any = "";
  onInquirySelect(item: any) {
    this.selectedInquiry = "";
    this.selectedInquiryId = "";
    this.selectedinquiry.forEach((element) => {
      this.selectedInquiry += element["itemName"] + ", ";
      this.selectedInquiryId += element["id"] + ", ";
    });
  }

  showCustomer: any = [];
  getcustomer() {
    let data = {};
    this.UserService.GetAllCustomer(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showCustomerArray = res;
        this.showCustomer = [];
        for (
          let i = 0;
          i < this.showCustomerArray["CustomerName"].length;
          i++
        ) {
          this.showCustomer.push({
            id: this.showCustomerArray["CustomerName"][i]["CompanyId"],
            itemName: this.showCustomerArray["CustomerName"][i]["CompanyName"],
          });
        }
      } else {
        this.showCustomerArray = [];
      }
    });
  }
  selectedcustomer: any = [];
  selectedCustomer: any;
  selectedCustomerId: any = "";
  onCustomerSelect(item: any) {
    this.selectedCustomer = "";
    this.selectedCustomerId = "";
    this.selectedcustomer.forEach((element) => {
      this.selectedCustomer += element["itemName"] + ", ";
      this.selectedCustomerId += element["id"] + ", ";
    });
  }

  showStage: any = [];
  getstage() {
    let data = {
      ModuleName: "OrderOverview",
    };
    this.UserService.GetStageList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showStageArray = res;
        this.showStage = [];
        for (const stageData of this.showStageArray["Data"]) {
          this.showStage.push({
            id: stageData["StageId"],
            itemName: stageData["StageName"],
          });
        }
      } else {
        this.showStageArray = [];
      }
    });
  }
  selectedstage: any = [];
  selectedStage: any;
  selectedStageId: any = "";
  onStageSelect(item: any) {
    this.selectedStage = "";
    this.selectedStageId = "";
    this.selectedstage.forEach((element) => {
      this.selectedStage += element["itemName"] + ", ";
      this.selectedStageId += element["id"] + ", ";
    });
  }

  SoOption: any = [];
  ddValues() {
    let data = {};
    this.UserService.GetOrderReviewDDValues(data).subscribe((res) => {
      if (res["result"] == "Success") {
        this.showDdValuesArray = res;
        this.SoOption = [];
        for (const option of this.showDdValuesArray["SOOption"]) {
          this.SoOption.push({
            id: option["Id"],
            itemName: option["Name"],
          });
        }
      } else {
        this.showDdValuesArray = [];
      }
    });
  }
  selectedSo: any = [];
  selectedSoName: any;
  selectedSoId: any;
  onSoSelect(item: any) {
    this.selectedSoName = "";
    this.selectedSoId = "";
    this.selectedSo.forEach((element) => {
      this.selectedSoName += element["itemName"];
      this.selectedSoId += element["id"];
    });
  }

  view(eid) {
    if (this.permission.OrderReview_View == 1 || this.roleId == 1) {
      localStorage.setItem("active_id", "tab-selectbyid9");
      let encryptid = this.UserService.encryptData(eid);
      encryptid = encryptid
        .toString()
        .replace("=", "Ar1t")
        .replace("/", "FGH")
        .replace("+", "THD");
      this.router.navigate(["/orderReview/detailsproductreview", encryptid]);
    } else {
      this.toastr.error("Permission Denied !");
    }
  }

  applyFilter() {
    this.currentPage = 0;
    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectNameId,
      CustomerId: this.selectedCustomerId,
      CriticalShipment: this.selectedCriticalId,
      Stage: this.selectedStageId,
      SOOption: this.selectedSoId,
      EquipmentDeliveryStartDate: this.start,
      EquipmentDeliveryEndDate: this.end,
      TargetCompletionStartDate: this.start2,
      TargetCompletionEndDate: this.end2,
      SearchWord: this.searchword,
      Status: "1, 2",
      Sort: this.namesort,
      SortWise: this.type,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.spinner.show();
    this.UserService.OrderReviewListFilter(data).subscribe((res) => {
      this.spinner.hide();
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.dataSource = new MatTableDataSource<any>(res["OrderReviewList"]);
      }
    });
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectNameId,
      CustomerId: this.selectedCustomerId,
      CriticalShipment: this.selectedCriticalId,
      Stage: this.selectedStageId,
      SOOption: this.selectedSoId,
      EquipmentDeliveryStartDate: this.start,
      EquipmentDeliveryEndDate: this.end,
      TargetCompletionStartDate: this.start2,
      TargetCompletionEndDate: this.end2,
      SearchWord: this.searchword,
      Status: "1, 2",
      Sort: this.namesort,
      SortWise: this.type,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.UserService.OrderReviewListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["OrderReviewList"]);
      }
    });
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.showOrder.slice(start, end);
    this.dataSource = part;
  }

  onSortData(sort: Sort) {
    this.currentPage = 0;
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { column: sort.active, direction: sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    } else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;
    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectNameId,
      CustomerId: this.selectedCustomerId,
      CriticalShipment: this.selectedCriticalId,
      Stage: this.selectedStageId,
      SOOption: this.selectedSoId,
      EquipmentDeliveryStartDate: this.start,
      EquipmentDeliveryEndDate: this.end,
      TargetCompletionStartDate: this.start2,
      TargetCompletionEndDate: this.end2,
      SearchWord: this.searchword,
      Status: "1, 2",
      Sort: this.namesort,
      SortWise: this.type,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.spinner.show();
    this.UserService.OrderReviewListFilter(data).subscribe((res) => {
      this.spinner.hide();
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.dataSource = new MatTableDataSource<any>(res["OrderReviewList"]);
      }
    });
  }

  dateChangeFun() {
    if (this.date_range && this.date_range != undefined) {
      if (this.date_range.startDate != null) {
        this.start_date = this.datePipe.transform(
          this.date_range.startDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.end_date = this.datePipe.transform(
          this.date_range.endDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.start_date = moment(this.start_date, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD");
        this.end_date = moment(this.end_date, "YYYY-MM-DD")
          .utc()
          .format("YYYY-MM-DD");
      } else {
        this.start_date = "";
      }
    }
  }

  tr: any;
  date: any;
  onSubmit() {
    this.multiClick = true;
    this.spinner.show();
    this.multiClick = true;
    this.showTable = false;
    this.currentPage = 0;
    this.spinner.show();

    if (
      this.date_range != null &&
      this.date_range.startDate != null &&
      this.date_range.startDate != "" &&
      this.date_range.endDate != "" &&
      this.date_range.endDate != null
    ) {
      this.start = this.datePipe.transform(
        this.date_range.startDate,
        "yyyy-MM-dd"
      );
      this.end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      this.start = "";
      this.end = "";
    }

    if (
      this.date_range2 != null &&
      this.date_range2.startDate2 != null &&
      this.date_range2.startDate2 != "" &&
      this.date_range2.endDate2 != "" &&
      this.date_range2.endDate2 != null
    ) {
      this.start2 = this.datePipe.transform(
        this.date_range2.startDate2,
        "yyyy-MM-dd"
      );
      this.end2 = this.datePipe.transform(
        this.date_range2.endDate2,
        "yyyy-MM-dd"
      );
    } else {
      this.start2 = "";
      this.end2 = "";
    }

    let data = {
      InquiryId: this.selectedInquiryId,
      ProjectId: this.selectedProjectNameId,
      CustomerId: this.selectedCustomerId,
      CriticalShipment: this.selectedCriticalId,
      Stage: this.selectedStageId,
      SOOption: this.selectedSoId,
      EquipmentDeliveryStartDate: this.start,
      EquipmentDeliveryEndDate: this.end,
      TargetCompletionStartDate: this.start2,
      TargetCompletionEndDate: this.end2,
      SearchWord: this.searchword,
      Status: "1, 2",
      Sort: this.namesort,
      SortWise: this.type,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.UserService.OrderReviewListFilter(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.multiClick = false;
          this.showTable = true;
          this.showOrder = res["OrderReviewList"];
          this.dataSource = new MatTableDataSource<any>(res["OrderReviewList"]);
          this.TotalRecord = res["TotalRecord"];
          this.tr = res["TotalRecord"];
          this.totalSize = this.TotalRecord;
          this.router.navigate(["/orderReview/orderreview"]);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
          this.multiClick = false;
        } else {
          this.toastr.error(res["Message"]);
          this.spinner.hide();
          this.multiClick = false;
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
        this.multiClick = false;
      }
    );
  }

  resetData() {
    this.selectedInquiryId = "";
    this.selectedProjectNameId = "";
    this.selectedCustomerId = "";
    this.selectedCriticalId = "";
    this.selectedStageId = "";
    this.selectedSoId = "";
    this.start = "";
    this.end = "";
    this.start2 = "";
    this.end2 = "";
    this.filterForm.reset();
    this.totalSize = this.tr;
    this.ngOnInit();
    this.isCollapsed = true;
  }

  edit(id) {
    localStorage.setItem("active_id", "tab-selectbyid1");
    let encryptid = this.UserService.encryptData(id);
    if (encryptid !== undefined) {
      encryptid = encryptid
        .toString()
        .replace("=", "Ar1t")
        .replace("/", "FGH")
        .replace("+", "THD");
      this.router.navigate(["/orderReview/editproductreview", encryptid]);
    } else {
      console.error("encryptid is undefined");
    }
  }

  deleteOpenModal(template: TemplateRef<any>, data, id, nam, name) {
    if (data) {
      this.deleteId = data;
      this.delstatus = id;
      this.PrName = nam;
      this.InqName = name;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline() {
    this.isValid = false;
    this.modalRef.hide();
  }

  deleteConfirm() {
    this.deleteOrder();
    this.modalRef.hide();
  }

  deleteOrder() {
    this.spinner.show();
    this.UserService.UpdateOrderStatus({
      OrderInfoId: this.deleteId,
      Status: this.delstatus,
    }).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.toastr.success("Order Deleted Successfully!");
        this.router
          .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("/orderReview/orderreview");
          });
      } else {
        this.err_message = response.Msg;
      }
    });
  }

  approveOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.approveId = data.OrderInfoId;
      this.PrName = data.ProjectName;
      this.InqName = data.InquiryName;
      this.Pid = data.ProjectNumber;
      this.Iid = data.InquiryNumber;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline1() {
    this.isValid = false;
    this.modalRef.hide();
  }

  approveConfirm() {
    this.approveOrder();
    this.modalRef.hide();
  }

  approveOrder() {
    this.spinner.show();
    this.UserService.ApproveOrderOverView({
      OrderInfoId: this.approveId,
    }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.toastr.success(response["Msg"]);
          this.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() => {
              this.router.navigateByUrl("/orderReview/orderreview");
            });
        } else if (response["result"] == "Failed") {
          this.toastr.error(response["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(response["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.success("Order Approved successfully");
        this.router
          .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("/orderReview/orderreview");
          });
      }
    );
  }

  rejectOpenModal(template: TemplateRef<any>, data, nam, name) {
    if (data) {
      this.rejectId = data;
      this.PrName = nam;
      this.InqName = name;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline2() {
    this.isValid = false;
    this.modalRef.hide();
  }

  rejectConfirm() {
    this.rejectOrder();
    this.modalRef.hide();
  }

  rejectOrder() {
    this.spinner.show();
    this.UserService.RejectOrder({
      OrderInfoId: this.rejectId,
      RejectReason: this.RejectForm.value.ResonValue,
    }).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.toastr.success("Order Rejected Successfully!");
        this.router
          .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("/orderReview/orderreview");
          });
      } else {
        this.err_message = response.Msg;
      }
    });
  }

  forwardOpenModal(template: TemplateRef<any>, data, nam, name) {
    if (data) {
      this.forwardId = data;
      this.PrName = nam;
      this.InqName = name;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline3() {
    this.isValid = false;
    this.modalRef.hide();
  }

  forwardConfirm() {
    this.forwardOrder();
    this.modalRef.hide();
  }

  forwardOrder() {
    this.spinner.show();
    this.UserService.ForwardOrder({
      OrderInfoId: this.forwardId,
      ForwardReason: this.ForwardForm.value.ResonValue,
    }).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.toastr.success("Order Forwarded Successfully!");
        this.router
          .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("/orderReview/orderreview");
          });
      } else {
        this.spinner.hide();
        this.err_message = response.Msg;
        this.toastr.error(this.err_message);
      }
    });
  }
}
